import clsx from 'clsx';
import { GatsbyImage } from 'gatsby-plugin-image';
import { twMerge } from 'tailwind-merge';

import { Container, Section } from 'components/GridV2';
import { Button } from 'components/rebrand/Button';
import CustomPortableText from 'components/rebrand/CustomPortableText';

import { IBenefit } from 'typescriptDefs/pages/new-to-canada';

import { useIsMobileSize } from 'helpers';

type Props = {
  benefits: IBenefit[];
};

const Benefits = ({ benefits }: Props) => {
  const isMobile = useIsMobileSize();
  return benefits.map(({ btnLink, btnText, content, img, imgAltText }, index) => (
    <Section className="py-64 md:py-96" key={index}>
      <Container className="px-32 xs:px-0">
        <div className="grid grid-cols-1 gap-40 md:grid-cols-2 md:gap-64">
          <GatsbyImage
            className={twMerge(clsx('rounded-16 md:h-600', (index % 2 !== 0 || isMobile) && 'order-last'))}
            image={img.asset.gatsbyImageData}
            alt={imgAltText}
          />
          <div
            className={twMerge(
              clsx(
                'my-auto [&_h2]:mb-8 [&_h2]:text-primary-350 md:[&_h2]:mb-24',
                (index % 2 !== 0 || isMobile) && 'order-first',
              ),
            )}
          >
            <CustomPortableText content={content} />
            <a className="mt-32 block w-fit md:mt-48" href={btnLink} target="_blank" rel="noopener noreferrer">
              <Button>{btnText}</Button>
            </a>
          </div>
        </div>
      </Container>
    </Section>
  ));
};

export default Benefits;
